import { checkIfAIVideoIsGenerating } from 'containers/SubSidebar/AIVideoContent/utils'
import { checkIfAIImageIsGenerating } from 'containers/SubSidebar/AiImageContent/utils'
import { generationProgressService } from 'services/generationProgress'
import { isLoadingFinalMandatoryValue } from 'utils'
import { IMediaItem } from 'types/media'

export const shouldRenderCanvasMediaItem = (mediaItem: IMediaItem) =>
  checkIfAIVideoIsGenerating(mediaItem) ||
  checkIfAIImageIsGenerating(mediaItem) ||
  isLoadingFinalMandatoryValue(
    generationProgressService.getProgress(mediaItem.id)
  )
